
// 当前页面是否是打印模式
let printMode = false;

// 开启打印模式
export function enablePrintMode() {
  printMode = true;
}

// 关闭打印模式
export function disabledPrintMode() {
  printMode = false;
}

// 判断当前是否开启打印模式
export function isPrintMode () {
  return printMode;
}

const printUtils = {
  isPrintMode,
  enablePrintMode,
  disabledPrintMode,
}

export type PrintUtils = typeof printUtils;

export { printUtils };
